export function utcDateTimeLocalToIso(value: string): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(value);
  if (!match) throw new Error('A UTC date and time is required');

  const [, year, month, day, hour, minute] = match;
  const milliseconds = Date.UTC(
    Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute)
  );
  const result = new Date(milliseconds);
  if (
    result.getUTCFullYear() !== Number(year) ||
    result.getUTCMonth() !== Number(month) - 1 ||
    result.getUTCDate() !== Number(day) ||
    result.getUTCHours() !== Number(hour) ||
    result.getUTCMinutes() !== Number(minute)
  ) throw new Error('The UTC date and time is invalid');
  return result.toISOString();
}
